import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "portal-header-content flex-align flex-between portal-page-width" }
const _hoisted_2 = { class: "left flex-align" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "logo-default"
}
const _hoisted_5 = {
  key: 2,
  class: "menu-list flex-align"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "right flex-align" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("注册")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("注册")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("退出")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.headerData.logo_url)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goMainPage())),
              src: _ctx.headerData.logo_url,
              class: _normalizeClass({ common_pointer: _ctx.headerData.microid }),
              alt: "logo"
            }, null, 10, _hoisted_3))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, "LOGO")),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerData.datas, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(['menu-item', {'current': index === _ctx.currentId }]),
                  key: item.link_id
                }, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => {_ctx.clickMenu(item, index);},
                    class: "font16 common_pointer"
                  }, _toDisplayString(item.title), 9, _hoisted_6)
                ], 2))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.headerData.search_status == '1')
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              placeholder: "请输入课程名称",
              class: _normalizeClass(['transition200ms', _ctx.showInputBox ? 'show' : 'hidden']),
              modelValue: _ctx.search,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.search = $event)),
              ref: "magnifier",
              size: _ctx.isMobile ? 'mini' : 'small',
              type: "search",
              onBlur: _ctx.blurMagnifier,
              onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.searchCourseName()), ["enter"]))
            }, {
              suffix: _withCtx(() => [
                _createElementVNode("i", {
                  class: "el-input__icon el-icon-search common_pointer font18 font-color",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clickMagnifier && _ctx.clickMagnifier(...args)), ["stop"])),
                  title: "搜索"
                })
              ]),
              _: 1
            }, 8, ["class", "modelValue", "size", "onBlur"]))
          : _createCommentVNode("", true),
        (_ctx.headerData.login_switch === '1')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["header-btn flex-align", [_ctx.isMobile ? 'common_mgl16' : 'common_mgl24']])
            }, [
              (_ctx.isMobile)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (!_ctx.portalToken)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goKeTangPai('login'))),
                          size: "medium",
                          type: "text"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.portalToken)
                      ? (_openBlock(), _createBlock(_component_el_divider, {
                          key: 1,
                          direction: "vertical"
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.portalToken)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 2,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goKeTangPai('regist'))),
                          size: "medium",
                          type: "text"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (!_ctx.portalToken)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goKeTangPai('login'))),
                          size: "medium",
                          type: "primary",
                          plain: ""
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.portalToken)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goKeTangPai('regist'))),
                          size: "medium",
                          type: "primary",
                          class: "common_mgl16"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 64)),
              (_ctx.portalToken)
                ? (_openBlock(), _createBlock(_component_el_dropdown, {
                    key: 2,
                    trigger: "click"
                  }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.removePortalToken()), ["stop"]))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_avatar, {
                        size: "large",
                        class: "common_pointer",
                        src: _ctx.userAvatar
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}